import { createContext, useContext } from "react";

export const FormPageContext = createContext();

export const useFormPageContext = () => {
  return useContext(FormPageContext);
};
